import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";

export const sbOptimizationRecommendationsApiDefinitions = prefixApi(
  "/api",
  apiBuilder({
    alias: "getSBOptimizationRecommendations",
    method: "post",
    path: "/gvads/sb-optimization-recommendations/",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: z.object({
          marketplace: z.string(),
          landing_pages: z.array(
            z.object({
              productIds: z.array(z.number()).optional(),
              pageType: z.string(),
              url: z.string().optional(),
            }),
          ),
        }),
      },
    ],
    status: 200,
    response: z.object({
      recommendedValue: z.number(),
      minimumValue: z.number(),
    }),
  }).build(),
);
